export default __webpack_public_path__ + "static/media/prize.211bc5aa.webp";